import api from "./auth";

export const uploadLogo = async (file) => {
  const formData = new FormData();

  formData.append("logo", file);

  const res = await api.post(
    "/api/upload/logo",
    formData
  );

  console.log("Cloudinary response:", res.data);

  if (!res.data.success) {
  throw new Error(
    res.data.message || "Upload failed"
  );
}
console.log(res.data);

  return res.data.url;
};